import LunarLander from '../../Assets/LunarLander.png';
import TempMeter from "../../Assets/TempMeter.png";
import MysqlExReact from "../../Assets/MysqlExReact.jpg";
import llamachat from "../../Assets/llamachat.png";
import Lammps from "../../Assets/Lammps.png";
import rocket from "../../Assets/rocket.png";
import LM35 from "../Md/LM35.md";
import MysqlExReactmd from "../Md/MysqlExReact.md";
import LunarLandermd from "../Md/LunarLander.md";
import llamachatmd from "../Md/llamachat.md";
import CompMat from "../Md/CompMat.md";
import RocketGame from "../Md/RocketGame.md";

const posts = [
    {
        id: 6,
        imageEksw: Lammps, 
        Titlos: "Computational Materials Science Projects", 
        Sigrafeas: "Klajdi", 
        Linksigrafea: "",  
        Date: "23 may 2026",
        Katigoria: "", 
        Keimeno: "This repository contains a collection of computational materials science and atomistic simulation projects developed using LAMMPS, Quantum ESPRESSO, OVITO, and Python. The projects focus on Molecular Dynamics (MD), Molecular Statics, Monte Carlo methods, nanoparticle simulations, and Density Functional Theory (DFT). The repository includes simulation input/output files, visualization results, Python-based data analysis and plotting scripts, and detailed PDF reports explaining the theoretical background, computational methodology, and analysis of each project.",
        Link: "https://github.com/Klajdis32/Computational-Materials-Science-Projects",
        htmlPdf: "",
        pdf: "",
        file: "",
        video: "",
        md: CompMat
    },
    {
        id: 5,
        imageEksw: TempMeter, 
        Titlos: "LM35 Temperature Meter – Arduino Uno", 
        Sigrafeas: "Klajdi", 
        Linksigrafea: "",  
        Date: "13 apr 2025",
        Katigoria: "", 
        Keimeno: "This project uses an LM35 analog temperature sensor connected to an Arduino Uno to measure ambient temperature in real time. The temperature readings are displayedon a 16x2 LCD screen. The LM35 sensor outputs a voltage that is linearly proportional to the temperature in degrees Celsius (10 mV per °C). The Arduino reads this analog voltage through pin A0, calculates the temperature, and updates the LCD display every 500 milliseconds. The LCD screen is connected directly to the Arduino using digital pins (RS, EN, D4–D7), and shows the current temperature with one decimal precision, e.g., “Temp: 24.7°C”. This project is a simple and effective way to monitor temperature using basic components and is ideal for beginners learning how to interface sensors and displays with Arduino.",
        Link: "",
        htmlPdf: "",
        pdf: "",
        file: "",
        video: "",
        md: LM35
    },
    {
        id: 4,
        imageEksw: MysqlExReact, 
        Titlos: "React-Express.js-MySQL Authentication System", 
        Sigrafeas: "Klajdi", 
        Linksigrafea: "",  
        Date: "1 feb 2025",
        Katigoria: "", 
        Keimeno: "This project is about a web application with a robust authentication system built using React for the frontend, Express.js for the backend, and MySQL as the database. User interaction with the backend is handled via cookies for authentication and session management. The application follows modern security best practices, including password hashing, token expiration handling, and CSRF protection. It also supports role-based access control (RBAC) to differentiate between user permissions, ensuring that only authorized users can access specific resources. Additionally, the frontend is designed with a responsive UI, providing a seamless experience across different devices. The backend API is structured using RESTful principles, making it scalable and easy to integrate with other services. ",
        Link: "https://github.com/Klajdis32/Express.js-React-MySQL-Authentication-System",
        htmlPdf: "",
        pdf: "",
        file: "",
        video: "",
        md: MysqlExReactmd
    },
    {
        id: 3,
        imageEksw: LunarLander, 
        Titlos: "Lunar Lander Ai Agent", 
        Sigrafeas: "Klajdi", 
        Linksigrafea: "",  
        Date: "17 dec 2024",
        Katigoria: "", 
        Keimeno: "This project focuses on training an agent to successfully land a lunar module on the flattest possible surface to avoid damage. The agent is trained using Reinforcement Learning (RL) techniques, specifically with the Proximal Policy Optimization (PPO) algorithm implemented in Ray RLlib. In the video generated, you can see the top 3 landings of the lunar module using the trained model. These landings demonstrate the agent's ability to control the lander effectively and achieve safe touchdowns.",
        Link: "https://github.com/Klajdis32/Lunar-Lander-Ai-Agent",
        htmlPdf: "",
        pdf: "",
        file: "",
        video: "",
        md: LunarLandermd
    },
    {
        id: 2,
        imageEksw: llamachat, 
        Titlos: "Chat Interface for Llama LLM", 
        Sigrafeas: "Klajdi", 
        Linksigrafea: "",  
        Date: "9 dec 2024",
        Katigoria: "", 
        Keimeno: "This project involves my attempt to create a web-based AI chat interface utilizing Meta's Llama-3.3-70B-Versatile model. Leveraging my knowledge of React, I developed a user-friendly platform offering natural and intelligent interaction, utilizing the advanced capabilities of this AI model.",
        Link: "https://github.com/Klajdis32/llama-chat-Interface-react",
        htmlPdf: "",
        pdf: "",
        file: "",
        video: "",
        md: llamachatmd
    },
    {
        id: 1,
        imageEksw: rocket, 
        Titlos: "Rocket Game With Python", 
        Sigrafeas: "Klajdi", 
        Linksigrafea: "",  
        Date: "25 Jul 2023",
        Katigoria: "", 
        Keimeno: "This project is a simple space-themed game created with Pygame, where the player controls a rocket and moves it left or right to avoid incoming obstacles. The rocket can shoot bullets to destroy enemies such as comets, UFOs, and robots, while the player earns points and advances through different levels. As the score increases, the game changes background, enemies, speed, and difficulty, making the gameplay more challenging. The project also includes a score/level panel and a Game Over screen with the option to restart or close the game.",
        Link: "https://github.com/Klajdis32/Rocket-Game-With-Python",
        htmlPdf: "",
        pdf: "",
        file: "",
        video: "",
        md: RocketGame
    },
    ];

export default posts;